import { addClinicCopy } from './addClinic';

/** Copy for the prescriber's REMS certification: the steps the Certification Checklist tracks, the first three, and the
 * Knowledge Assessment's opening view. */
export const certificationCopy = {
  title: 'FINTEPLA® REMS Prescriber Certification',
  description: 'Verify your information for your REMS certification.',
  checklist: {
    title: 'Certification checklist',
    /** Read by screen readers on each step's icon. */
    status: { done: 'Done', notDone: 'Not done' },
    steps: {
      prescriber: 'Prescriber information',
      clinic: 'Clinic information',
      officeContact: 'Primary office contact',
      assessment: 'Knowledge assessment',
      signature: 'Signature',
    },
  },
  prescriber: {
    title: 'Prescriber information',
    npi: {
      label: 'Match NPI',
      helperText: '10-digit National Provider Identifier',
      /** A valid NPI that matches no prescriber on file. */
      noMatch: 'No prescriber matches that NPI. Check the number and try again.',
    },
    labels: { npi: 'NPI', specialty: 'Specialty', email: 'Email', phone: 'Phone' },
    missingValue: '-',
    confirm: 'Confirm',
    edit: 'Edit',
  },
  clinic: {
    title: 'Clinic information',
    description: 'The primary clinic location where you will be prescribing FINTEPLA.',
    select: 'Select clinic',
    labels: { phone: 'Phone', fax: 'Fax' },
    missingValue: '-',
    missingInformation: {
      title: 'Our records are missing some information required for REMS certification.',
      body: 'Please add the additional information.',
    },
    placeholders: { phone: '(000) 000-0000', fax: '(000) 000-0000' },
    addClinic: addClinicCopy.action,
    inProcess: 'In Process',
    confirm: 'Confirm',
  },
  officeContact: {
    title: 'Primary office contact',
    description: 'Enter the info for the point of contact regarding this prescriber’s enrollment.',
    labels: {
      firstName: 'First name',
      lastName: 'Last name',
      email: 'Email',
      phone: 'Phone',
      preferredCommunicationMethod: 'Preferred communication method',
      fax: 'Fax',
    },
    placeholders: { phone: '(000) 000-0000', preferredCommunicationMethod: 'Select one…', fax: '(000) 000-0000' },
    optional: 'Optional',
    missingValue: '-',
    contactMethods: { Email: 'Email', Phone: 'Phone', Fax: 'Fax' },
    /** Confirms the contact and moves on to the Knowledge Assessment. */
    confirm: 'Review forms',
    edit: 'Edit',
  },
  assessment: {
    /** The page's description once the prescriber reaches the Knowledge Assessment. */
    description:
      'To prescribe FINTEPLA, simply complete this brief certification to align with the Risk Evaluation and Mitigation Strategy (REMS) program.',
    referenceMaterials: {
      title: 'REMS reference materials',
      noteLabel: 'Note:',
      note: 'Please review all 3 reference materials to unlock the assessment.',
      reviewed: 'Reviewed',
    },
    materials: {
      prescribingInformation: 'Prescribing information',
      prescriberTraining: 'Prescriber training',
      remsProgramOverview: 'REMS program overview',
    },
    begin: 'Begin assessment',
    scoreNote: {
      label: 'Note:',
      lines: [
        'A score of 100% (9/9) is required for certification.',
        'You’ll have multiple chances to complete the assessment if you miss a question.',
      ],
    },
    /** Shown once the assessment begins, until its questions are built. */
    comingSoon: 'The assessment questions are coming soon.',
  },
} as const;
